import { ENTRY_RESULT_RECORD_KEY } from 'client/config/entryConfig';
import { EXTRA_UPLOAD_FEATURE_TYPES } from 'config/gameSettingConfig';

// 編輯器存入的設定值
export const AI_SETTING_KEY = {
    // 生成結果圖
    ENABLE_RESULT_IMAGE: 'enableResultImage',
    // 生成結果音樂
    ENABLE_RESULT_AUDIO: 'enableResultAudio'
};

// AI 類型
export const AI_EXTENSION_TYPE = {
    // 圖片上傳生成圖片
    IMAGE_UPLOAD_TO_IMAGE: 1,
    // 心理測驗結果生成音樂
    PSYCHOMETRIC_TEST_TO_AUDIO: 2
};

/**
 * AI Job 狀態
 * @enum {number}
 * @property {number} PENDING - 等待請求中 (0)
 * @property {number} PROCESSING - 處理中 (1)
 * @property {number} COMPLETED - 執行完成 (2)
 * @property {number} FAILED - 失敗 (3)
 * @property {number} TIME_OUT - time out (4)
 */
export const AI_JOB_STATUS = {
    PENDING: 0,
    PROCESSING: 1,
    COMPLETED: 2,
    FAILED: 3,
    TIME_OUT: 4
};

/**
 * 檢查是否有啟用任何 AI 設定
 * @param {Object} settings - AI 設定物件
 * @returns {boolean} 如果有任何一個 AI 設定被啟用則回傳 true，否則回傳 false
 */
export const isEnableAISettingKey = settings => {
    if (!settings || typeof settings !== 'object') return false;

    return !Object.values(AI_SETTING_KEY).every(key => !Boolean(settings[key]));
};

// 上傳圖片、創意相框對應 Entry Result Record Key
export const EXTRA_UPLOAD_FEATURE_MAP = {
    // 上傳圖片
    [EXTRA_UPLOAD_FEATURE_TYPES.IMAGE_UPLOAD]: ENTRY_RESULT_RECORD_KEY.IMAGE_UPLOAD,
    // 創意相框
    [EXTRA_UPLOAD_FEATURE_TYPES.CREATIVE_FRAME]: ENTRY_RESULT_RECORD_KEY.CREATIVE_FRAME
};

// 生成結果圖、生成結果音樂對應 Entry Result Record Key
export const AI_SETTING_MAP = {
    // 生成結果圖
    [AI_SETTING_KEY.ENABLE_RESULT_IMAGE]: ENTRY_RESULT_RECORD_KEY.GENERATIVE_IMAGE_EXTENSION,
    // 生成結果音樂
    [AI_SETTING_KEY.ENABLE_RESULT_AUDIO]: ENTRY_RESULT_RECORD_KEY.GENERATIVE_AUDIO_EXTENSION
};

// 編輯位置，Config 會設定好對應的位置
export const EDITOR_AREA_TYPE = {
    RESULT: 'result'
};
